'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/snapshot-dates-chart-tooltip.html'));
var SnapshotDatesChartController = function SnapshotDatesChartController($scope, $rootScope, formatter, momentService, dataService, mapService, summaryDashboardLegendFilterService, $filter, hepService) {
  var minimalSelectionSize = 30;
  var rmNumberFormat = $filter('rmNumberFormat');
  var rmMomentFormat = $filter('rmMomentFormat');
  var fieldsToBroadcast = ['effectedServices', 'excludedServices', 'extendedServices', 'recommendations', 'snapshotDate', 'cabins', 'markets', 'poses', 'direction', 'runNumber'];
  var runFrequency = hepService.getSimpleHepProperty('DYNAMIC_PRICING_RECOM_FREQUENCY');
  $scope.chartFormatters = {
    yAxisTickFormatter: formatter.humanReadable,
    xAxisTickFormatter: formatter.runNumberWithYearTick('DAY_MONTH_SHORT_NAME_YEAR', 'DAY_MONTH_SHORT_NAME', 'DAY_OF_MONTH', 'runNumber', getData, true, runFrequency),
    tooltipFormatter: function tooltipFormatter(d) {
      var tooltipModel = {
        snapshotDate: rmMomentFormat(d.snapshotDate, 'DATE_USER_SETTINGS'),
        runNumber: parseInt(d.runNumber.slice(8, 9)),
        showRunNumber: runFrequency > 1,
        metricValue: rmNumberFormat(d[mapService.getMapComponent('scaleMetric')], 'NUMBER'),
        effectedServices: rmNumberFormat(d.effectedServices, 'NUMBER'),
        excludedServices: rmNumberFormat(d.excludedServices, 'NUMBER'),
        extendedServices: rmNumberFormat(d.extendedServices, 'NUMBER'),
        recommendations: rmNumberFormat(d.effectedServices + d.excludedServices, 'NUMBER'),
        newServices: rmNumberFormat(d.effectedServices - d.extendedServices, 'NUMBER'),
        metricLabel: mapService.getMapComponent('metricTooltipLabel')
      };
      return tooltipTemplate(tooltipModel);
    }
  };
  $scope.viewportFormatters = {
    xAxisTickFormatter: formatter.runNumberMonthTick('MONTH', 'runNumber', getData, runFrequency)
  };

  /**
   * Initialize Chart
   */
  $scope.initChart = function () {
    $scope.setLoadingMessage();
    $scope.resetChart();
    $scope.reloadChart();
  };
  $scope.viewportReset = function () {
    $scope.resetRange();
    $scope.reloadChart();
  };
  $scope.resetFilters = function () {
    if (!$scope.onResetBrushes) {
      return;
    }
    $scope.onResetBrushes();
  };
  $scope.resetChart = function () {
    $scope.resetRange();
    $scope.resetSnapshotDate();
    $scope.resetLegendFilters();
  };
  $scope.changeMetric = function (selectedMetric) {
    $scope.$evalAsync(function () {
      mapService.setMapComponent('yRightLabel', selectedMetric.chartLabel);
      mapService.setMapComponent('metricTooltipLabel', selectedMetric.tooltipLabel);
    });
  };
  $scope.resetSnapshotDate = function () {
    $scope.snapshotDateMoment = undefined;
  };
  $scope.resetLegendFilters = function () {
    summaryDashboardLegendFilterService.resetFilters();
  };
  $scope.resetRange = function () {
    $scope.currentRange = undefined;
  };
  function getSnapshotDate() {
    return _.find($scope.data, {
      'snapshotDate': $scope.snapshotDateMoment,
      'runNumber': $scope.runNumber
    });
  }
  function getData() {
    return $scope.data;
  }
  function renderChart(chartData, range) {
    $scope.selectionSize = chartData.length > minimalSelectionSize ? minimalSelectionSize : chartData.length;
    if ($scope.selectionSize > minimalSelectionSize) {
      $scope.selectionSize = minimalSelectionSize;
    }
    $scope.currentRange = range || $scope.currentRange;
    if (summaryDashboardLegendFilterService.isFilterEmpty()) {
      $scope.originalData = chartData;
    }
    $scope.data = chartData;
    if ($scope.snapshotDateMoment) {
      $scope.broadcastSelectedSnapshotData(getSnapshotDate(), true);
    } else {
      $scope.broadcastSelectedSnapshotData(_.last($scope.data), false);
    }
  }
  $scope.reloadChart = _.debounce(function (range, resetSelection) {
    if (resetSelection) {
      $scope.resetRange();
    }
    return dataService.getData().then(_.partialRight(renderChart, range));
  }, 80);
  $scope.hasData = function () {
    return $scope.data && $scope.data.length !== 0 || $scope.originalData && $scope.originalData.length !== 0;
  };
  $scope.broadcastSelectedSnapshotData = function (snapshotDateData, changeSelection) {
    $scope.resetFilters();
    var currentSnapshotDate;
    if (snapshotDateData) {
      if (changeSelection) {
        changeBarSelection(snapshotDateData.snapshotDate, snapshotDateData.runNumber);
      }
      var metrics = snapshotDateData.metrics;
      snapshotDateData = _.pick(snapshotDateData, fieldsToBroadcast);
      snapshotDateData.newServices = snapshotDateData.effectedServices - snapshotDateData.extendedServices;
      _.merge(snapshotDateData, metrics);
      currentSnapshotDate = _.last($scope.data);
    }
    $rootScope.$broadcast('Chart:SnapshotDates:selectedSnapshotDate', snapshotDateData, _.get(currentSnapshotDate, 'snapshotDate'), _.get(currentSnapshotDate, 'runNumber'));
    $scope.renderChart($scope.data, $scope.selectionSize);
  };
  function changeBarSelection(selectedSnapshotDate, selectedRunNumber) {
    $scope.snapshotDateMoment = selectedSnapshotDate;
    $scope.runNumber = selectedRunNumber;
    $scope.data = _.transform($scope.data, function (result, value) {
      value.selected = value.runNumber === selectedRunNumber;
      result.push(value);
    }, []);
  }
};
SnapshotDatesChartController.$inject = ['$scope', '$rootScope', 'FormatterService', 'MomentService', 'SnapshotDatesChartDataService', 'SnapshotDatesMapDataToChartComponentsService', 'SummaryDashboardLegendFilterService', '$filter', 'HepService'];
module.exports = SnapshotDatesChartController;